import { ModuleName } from "../Lib/AxSystem/AxInit";

@ModuleName("AxChipcardHint")
export class AxChipcardHint {
    ShowChipCardHint(chipCardType) {
        const $modal = $('#chipCardHintModal');
        const $img = $('#chipCardHintImage');
        const $error = $('#chipCardHintError');
        $img.off('load error');
        $img.css('opacity', 0).removeClass('d-none');
        $error.addClass('d-none');

        $img.on('load', function () {
            $img.animate({ opacity: 1 }, 200);
            $error.addClass('d-none');
        });

        $img.on('error', function () {
            $img.addClass('d-none');
            $error.removeClass('d-none');
        });

        $img.attr('alt', chipCardType);
        $img.attr('src', '/ChipCardHintImage/' + chipCardType);
        $modal.modal('show');
    }
}